import script from "./SampleGroup.vue?vue&type=script&setup=true&lang=js"
export * from "./SampleGroup.vue?vue&type=script&setup=true&lang=js"

import "./SampleGroup.vue?vue&type=style&index=0&id=5594f705&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5594f705"]])

export default __exports__